import React, { useState } from "react";
import categoryInfo from "../../categoryInfo.json";
import SectionLandingLikePublications from "../common/SectionLandingLikePublications";

export default function FinancialMarket() {
  const [post] = useState(() => categoryInfo.financialmarket ?? []);

  const lead = (
    <>
      <p>
        A financial market is a marketplace where financial instruments are issued and/or traded. It plays a
        vital role in the smooth functioning of the modern economy as it enables investors to efficiently
        allocate their funds, manage risk, and respond to market movements.
      </p>
      <p>
        It is mainly through the financial markets that the Central Bank Rate (CBR) influences interest rates
        and ensures a market-driven exchange rate. This helps the central bank achieve its monetary policy
        objectives. At the National Bank of Rwanda (NBR), monetary policy implementation and issuance of
        government securities are undertaken by the Financial Markets Department, which also publishes the
        official exchange rate and supports foreign exchange reserves management.
      </p>
    </>
  );

  return (
    <SectionLandingLikePublications
      breadcrumbCurrent="Financial Markets"
      headingId="financial-market-bnr-heading"
      pageTitle="Financial Markets"
      tagline="Markets, rates and official exchange rates"
      sharePageTitle="Financial Markets — National Bank of Rwanda"
      lead={lead}
      posts={post}
      pageFeedbackPath="/financialmarket"
    />
  );
}
